/* eslint-disable */

export function loadGtmIfNeed(gtmId: string) {
    const w: any = window;

    if (w.dataLayer != null) {
        return;
    }

    w.dataLayer = w.dataLayer || [];

    const script = document.createElement('script');

    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtm.js?id=' + gtmId;

    const head = document.querySelector('head');
    head?.appendChild(script);
}
